module.exports = __webpack_public_path__ + "favicon-impersonate-7bbc00146ed11c0f9fd97d746570ffca.svg";